import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  type WHLocationPaginateParams,
  type WHLocationPaginateResult,
  warehouseApis,
} from '../../../gateways/breadstack/warehouseApis'

export const locationListQueryKey = (
  storeId: string,
  organizationId: string | undefined,
  page: number,
  limit: number,
  search: string,
) =>
  [
    'locations-paginate',
    storeId,
    organizationId ?? null,
    page,
    limit,
    search,
  ] as const

export const useLocationListQuery = (input: WHLocationPaginateParams) =>
  useQuery<WHLocationPaginateResult>({
    queryKey: locationListQueryKey(
      input.storeId,
      input.organizationId,
      input.page,
      input.limit,
      input.search ?? '',
    ),
    queryFn: () => warehouseApis.paginate(input),
    enabled: Boolean(input.storeId),
    placeholderData: keepPreviousData,
  })
